<template>
  <section>
    <div class="container">
      <custom-title-block :title="title" />
      <subdivision-choose-content
        :subtitle="subtitle"
        :subdivisions="subDivision"
        :moving-block-text="movingBlockText"
      />
    </div>
  </section>
</template>

<script>
import CustomTitleBlock from "@/components/UI/CustomTitle.vue";
import SubdivisionChooseContent from "@/components/main/subDivisionChoose/methods/SubDivisionChooseContent.vue";

export default {
  name: "subdivision-choose",
  components: { SubdivisionChooseContent, CustomTitleBlock },
  data() {
    return {
      title: "ВИБІР ПІДРОЗДІЛУ",
      subtitle: [
        "Проєкт",
        "Drone Force",
        "дозволяє обирати підрозділ Сухопутних військ Збройних Сил України, " +
          "в якому новобранець бажає проходити службу. Завдяки цьому, кожен має " +
          "можливість приєднатися до тієї частини, яка найбільше відповідає " +
          "його інтересам та бойовому духу, сприяючи ефективному виконанню " +
          "завдань та враховує побажання рекрута.",
      ],
      movingBlockText: "Ти можеш розглянути кілька варіантів:",
      subDivision: [
        {
          id: 1,
          name: "НРК",
          type: "small-block",
          imgs: [1, 2, 3, 4, 5, 6],
        },
        {
          id: 2,
          name: "Лінія дронів",
          type: "small-block",
          imgs: [7, 8, 9, 10],
        },
        {
          id: 3,
          name: "Будь-який підрозділ безпілотних систем Сухопутних військ",
          type: "big-block",
          imgs: [
            11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27,
            28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44,
            45,
          ],
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.container {
  margin-bottom: 60px;
}
</style>
